import React from 'react';
import Icon from './Icon';
import classNames from 'classnames';

class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            x : 0,
            y : 0,
            focus : false
        };

        this.togglePopup = this.togglePopup.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onMouseAction = this.onMouseAction.bind(this);
    }

    togglePopup() {
        this.setState({toggle: !this.state.toggle});
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside() {
        if (this.state.focus) {
            this.props.handleClose();
        }
    }

    onMouseAction(e){
        let x = e.clientX;
        let y = e.clientY;
        let currentX = this.state.x;
        let currentY = this.state.y;
        let focus = false;
        if( (x >= (currentX - 40) && x <= (currentX + 40)) && (y >= (currentY - 40) && y <= (currentY + 40)) && this.wrapperRef && !this.wrapperRef.contains(e.target)){
            focus = true;
        }
        this.setState({x,y, focus});
    }

    render() {
        //console.log(this.state);
        return this.props.toggle ? (
            <div
                className={classNames('popup', `${this.props.className ? this.props.className : ""}`, {'light': !!this.props.light})}
                onClick={(e) => this.handleClickOutside(e)}
                onMouseUp={(e)=>this.onMouseAction(e)}
                onMouseDown={(e)=>this.onMouseAction(e)}
                >
                <Icon type="close" className="close-popup"/>
                <div
                    className="popup-container"
                    onClick={(e) => e.stopPropagation()}
                    ref={this.setWrapperRef}
                >
                        {this.props.children}
                </div>
            </div>
        ) : null
    }
}

export default Popup;
